import { jsx as _jsx } from "react/jsx-runtime";
import { IconProvider } from "@ant-design/icons";
import { App, ConfigProvider } from "antd";
import { wpAdminAntdTheme } from "@devowl-wp/utils";
import { RootStore } from "../store/stores.js";
const Provider = ({ children, configProvider = {}, app = {} })=>/*#__PURE__*/ _jsx(ConfigProvider, {
        prefixCls: process.env.ANTD_PREFIX,
        iconPrefixCls: `${process.env.ANTD_PREFIX}-anticon`,
        tag: {
            variant: "outlined"
        },
        ...configProvider,
        theme: wpAdminAntdTheme,
        children: /*#__PURE__*/ _jsx(IconProvider, {
            value: {
                prefixCls: `${process.env.ANTD_PREFIX}-anticon`
            },
            children: /*#__PURE__*/ _jsx(App, {
                message: {
                    top: 50
                },
                ...app,
                children: /*#__PURE__*/ _jsx(RootStore.StoreProvider, {
                    children: children
                })
            })
        })
    });
export { Provider };
